<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      class="form-input">
      <el-form-item
        :label="$attrs.name"
        :rules="$attrs.props.rules"
        :class="{isRequired: !isRequired}"
        prop="newValue"
        class="item"
      >
        <app-qiniu
          v-model="form.newValue"
          token-url="/resource/upload_token"
          token-mode="name"
          width="100%"
          height="100%"
          type="animation"
          preview
        >
          <span
            slot="placeholder"
            class="state-primary-icon"
          >
            选择需要上传游戏的压缩包
          </span>
        </app-qiniu>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { common } from "../../mixins/common";

export default {
  name: 'ImSelectFile',
  mixins: [common],
};
</script>

<style scoped>
.form-input{
  display: flex;
  flex-direction: row;
}
.item{
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 20px;
}
.item >>> .el-form-item__content{
  width: 20vw;
  height: 40px;
}

.item >>> .iconfont{
  font-size: 22px;
}
.isRequired{
  padding-left: 10px;
}
</style>
